import { Component, Vue } from 'vue-property-decorator';

import { METRICS } from '@/_helpers/constants.js';
// import { loadScript } from '@/_helpers/utils.js';

@Component
class SetMetricsMixin extends Vue {
  private host = window.location.hostname;
  private hostArray = this.host.split('.');
  private domain = `${this.hostArray.slice(this.hostArray.length - 1)}`;
  private location = window.location.pathname;
  // private facebookId = METRICS.facebookId.registration_ru;

  public set_metrics() {
    let yandexId = '';
    // let googleId = '';
    // let gtmId = '';

    if (this.domain === 'ru' || this.domain === 'localhost' || this.domain === 'team') {
      if (this.location.indexOf('/registration/') === 0) {
        yandexId = METRICS.yandexId.registration_ru;
        // googleId = METRICS.googleId.registration_ru;
      } else {
        yandexId = METRICS.yandexId.ru;
        // googleId = METRICS.googleId.ru;
      }

      // gtmId = "GTM-P2QPQQG";
    } else {
      if (this.location.indexOf('/registration/') === 0) {
        yandexId = METRICS.yandexId.registration_en;
        // googleId = METRICS.googleId.registration_en;
      } else {
        yandexId = METRICS.yandexId.ai;
        // googleId = METRICS.googleId.ai;
      }

      // gtmId = "GTM-KDSTXSF";
    }

    setTimeout(() => {
      this.$nextTick(() => {
        // Yandex.Metrika counter
        if (this.location.indexOf('/registration/') === 0) {
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

          ym(yandexId, "init", {
                clickmap:true,
                trackLinks:true,
                accurateTrackBounce:true,
                webvisor:true
          });
        } else {
          (function (d, w, c, callback) {
              (w[c] = w[c] || []).push(function() {
                  try {
                      w[`yaCounter${yandexId}`] = new Ya.Metrika({
                          id:yandexId,
                          clickmap:true,
                          trackLinks:true,
                          accurateTrackBounce:true
                      });
                  } catch(e) { }
              });

              var n = d.getElementsByTagName("script")[0],
                  s = d.createElement("script"),
                  f = function () { n.parentNode.insertBefore(s, n); };
              let r;
              r = false;
              s.type = "text/javascript";
              s.async = true;
              s.src = "https://mc.yandex.ru/metrika/watch.js";
              s.onload = s.onreadystatechange = function() {
                if (!r && (!this.readyState || this.readyState === 'complete')) {
                  r = true;
                  if (callback) {
                    callback();
                  }
                }
              };

              if (w.opera == "[object Opera]") {
                  d.addEventListener("DOMContentLoaded", f, false);
              } else { f(); }
          })(document, window, "yandex_metrika_callbacks", () => {
            this.$store.commit('services/changeMetricsLoaded', true);
          });
        }
        // End Yandex.Metrika counter

        // loadScript(`https://www.googletagmanager.com/gtag/js?id=${googleId}`)

        // window.dataLayer = window.dataLayer || [];
        // function gtag(){
        //   dataLayer.push(arguments[0]);
        // }
        // window.gtag = gtag;
        // gtag('js', new Date());

        // gtag('config', googleId);

        // if (this.facebookId) {
        //   // Facebook Pixel Code
        //   !function(f,b,e,v,n,t,s)
        //   {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        //   n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        //   if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        //   n.queue=[];t=b.createElement(e);t.async=!0;
        //   t.src=v;s=b.getElementsByTagName(e)[0];
        //   s.parentNode.insertBefore(t,s)}(window, document,'script',
        //   'https://connect.facebook.net/en_US/fbevents.js');
        //   fbq('init', this.facebookId);
        //   fbq('track', 'PageView');
        //   // End Facebook Pixel Code
        // }

        // gtm.js
        // (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        // })(window,document,'script','dataLayer', gtmId);
      })
    }, 1000);
  };

  mounted() {
    this.set_metrics();
  }
}

export default SetMetricsMixin;
